import { http, formatURI } from './public'

export const aldServiceApi = {
    syncLeaderData(){
        return http.fetchPost("/services/ald/fee/syncLeaderData", null)
    },
    findProductPageList(params, page){
        let url = formatURI('/services/ald/product/findProductPageList/page/{0}/{1}', page.pageSize, page.pageNum)
        return http.fetchPost(url, params)
    },
    findProductAllList(){
        return http.fetchPost("/services/ald/product/findAll", null)
    },
    updateProduct(params){
        return http.fetchPost('/services/ald/product/updateProduct', params)
    },
    updateProductStatus(params){
        return http.fetchPost('/services/ald/product/updateStatus', params)
    },
    findOrderPageList(params, page){
        let url = formatURI('/services/ald/order/findOrderPageList/page/{0}/{1}', page.pageSize, page.pageNum)
        return http.fetchPost(url, params)
    },
    findOrderProfitPageList(params, page){
        let url = formatURI('/services/ald/orderProfit/findOrderProfitPageList/page/{0}/{1}', page.pageSize, page.pageNum)
        return http.fetchPost(url, params)
    },
    findTokenProfitPageList(params, page){
        let url = formatURI('/services/ald/tokenProfit/findTokenProfitPageList/page/{0}/{1}', page.pageSize, page.pageNum)
        return http.fetchPost(url, params)
    },
    findTokenReleasePageList(params, page){
        let url = formatURI('/services/ald/tokenProfit/findTokenReleasePageList/page/{0}/{1}', page.pageSize, page.pageNum)
        return http.fetchPost(url, params)
    },
    findRewardPageList(params, page){
        let url = formatURI('/services/ald/reward/findRewardPageList/page/{0}/{1}', page.pageSize, page.pageNum)
        return http.fetchPost(url, params)
    },
    countReward(params){
        return http.fetchPost('/services/ald/reward/countReward', params)
    },
    sendRward(params){
        return http.fetchPost('/services/ald/reward/sendRward', params)
    },
    orderProfitTask(){
        return http.fetchPost('/services/ald/test/orderProfitTask', null)
    },
    tokenProfitTask(){
        return http.fetchPost('/services/ald/test/tokenProfitTask', null)
    },
    tokenReleaseTask(){
        return http.fetchPost('/services/ald/test/tokenReleaseTask', null)
    },
    findWithdrawPageList(params, page){
        let url = formatURI('/services/ald/withdraw/findPageList/page/{0}/{1}', page.pageSize, page.pageNum)
        return http.fetchPost(url, params)
    },
    // 借贷池订单：暂停/恢复（后台同步暂停分红）
    pauseOrder(id){
        return http.fetchPost('/services/ald/order/pause', { id })
    },
    resumeOrder(id){
        return http.fetchPost('/services/ald/order/resume', { id })
    },
    findFee(){
        return http.fetchPost('/services/ald/fee/findFee', null);
    },
    sendFee(){
        return http.fetchPost('/services/ald/fee/sendFee', null);
    }
}